import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
	useAllItemsQuery,
	useCreateItemMutation,
	useEditItemByIdMutation,
	useDeleteItemByIdMutation
} from '../../../store/api/item.api.js';
import styles from '../PromoAdminPage/PromoAdminPage.module.css';
import { XboxModal } from '../Modal/XboxModal/XboxModal';

const SubRow = ({ sub, onEdit, onDelete }) => (
	<div className={styles.row}>
		<div>{sub.id}</div>
		<div>{sub.price}₽</div>
		<div>{sub.price_disc}₽</div>
		<div>{sub.time} мес.</div>
		<div>{sub.type}</div>
		<div className={styles.actionsInline}>
			<span onClick={() => onEdit(sub)} className={styles.actionText}>Редактировать</span>
			<span onClick={() => onDelete(sub.id)} className={styles.actionText}>Удалить</span>
		</div>
	</div>
);

export const XboxAdminPage = () => {
	const schema = window.sessionStorage.getItem('schema');
	const navigate = useNavigate();
	const { data: subs = [], isLoading, refetch } = useAllItemsQuery({ schema });
	const [createMode, setCreateMode] = useState(false);
	const [editSub, setEditSub] = useState(null);
	const [searchQuery, setSearchQuery] = useState('');
	const [currentPage, setCurrentPage] = useState(1);

	const SUBS_PER_PAGE = 20;

	const [createSub] = useCreateItemMutation();
	const [updateSub] = useEditItemByIdMutation();
	const [deleteSub] = useDeleteItemByIdMutation();

	const handleCloseModal = () => {
		setCreateMode(false);
		setEditSub(null);
	};

	const handleSubSubmit = async (data) => {
		try {
			if (editSub) {
				data = {
					...data,
					 time: Number(data.time),
				}
				await updateSub({ itemId: editSub.id, data, schema }).unwrap();
			} else {
				await createSub({data, schema}).unwrap();
			}
			refetch();
			handleCloseModal();
		} catch {
			alert('Ошибка при сохранении подписки');
		}
	};

	const handleDelete = async (id) => {
		if (window.confirm('Удалить подписку?')) {
			try {
				await deleteSub({ itemId: id, schema }).unwrap();
				refetch();
			} catch {
				alert('Ошибка при удалении подписки');
			}
		}
	};

	const filteredSubs = subs.filter(sub =>
		`${sub.price}${sub.time}`.includes(searchQuery)
	);

	const totalPages = Math.ceil(filteredSubs.length / SUBS_PER_PAGE);

	const subsToShow = filteredSubs.slice(
		(currentPage - 1) * SUBS_PER_PAGE,
		currentPage * SUBS_PER_PAGE
	);

	if (isLoading) return <div className={styles.loading}>Загрузка...</div>;

	return (
		<div className={styles.main}>
			<div className={styles.backWrapper}>
				<button className={styles.backButton} onClick={() => navigate('/admin')}>
					← Назад
				</button>
			</div>

			<h2 className={styles.title}>Подписки Xbox</h2>

			<div className={styles.buttonWrapper}>
				<button className={styles.addButton} onClick={() => setCreateMode(true)}>
					Добавить подписку
				</button>
			</div>

			<div className={styles.searchWrapper}>
				<input
					type="text"
					value={searchQuery}
					onChange={(e) => {
						setSearchQuery(e.target.value);
						setCurrentPage(1);
					}}
					placeholder="Поиск по цене или времени..."
					className={styles.searchInput}
				/>
			</div>

			<div className={styles.header}>
				<div>ID</div>
				<div>Цена</div>
				<div>Цена со скидкой</div>
				<div>Время</div>
				<div>Тип</div>
				<div></div> {/* Действия */}
			</div>

			<div className={styles.list}>
				{subsToShow.map(sub => (
					<SubRow
						key={sub.id}
						sub={sub}
						onEdit={setEditSub}
						onDelete={handleDelete}
					/>
				))}
			</div>

			{totalPages > 1 && (
				<div className={styles.pagination}>
					<button
						onClick={() => setCurrentPage(currentPage - 1)}
						disabled={currentPage === 1}
						className={styles.pageButton}
					>
						Назад
					</button>
					<span className={styles.pageInfo}>
						Страница {currentPage} из {totalPages}
					</span>
					<button
						onClick={() => setCurrentPage(currentPage + 1)}
						disabled={currentPage === totalPages}
						className={styles.pageButton}
					>
						Вперёд
					</button>
				</div>
			)}

			{(createMode || editSub) && (
				<XboxModal
					isOpen={createMode || !!editSub}
					onClose={handleCloseModal}
					onSubmit={handleSubSubmit}
					initialData={editSub}
				/>
			)}
		</div>
	);
};
